export default "__VITE_ASSET___Pt$pe4$__"